module.exports = __webpack_public_path__ + "static/z16-2-0003-tablet-95b1f061ffd6237f75ad019ebb0c2965.jpg";